import en from './en'

export default {
    en
}



// WEBPACK FOOTER //
// src/lang/locales/index.js